import axios from "axios";
import { authHeader } from "../authservice/auth-header";

const API_URL =process.env.VUE_APP_ROOT_API

class HouseKeepingService {
  // MINI BAR RELATED APIs

  // get all mini bar item
  getMiniBarItemStock(room_id) {
    return axios
      .get(API_URL + "hk/" + room_id + "/mini-bar-inventory", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // get all mini bar item
  updateMiniBarItemStock(room_id, item_id, data) {
    return axios
      .patch(
        API_URL + "hk/" + room_id + "/mini-bar-inventory/" + item_id,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  // HOUSE KEEPING RELATED AND META DATA SETTING

  // CHECK LIST RELATED APIs

  // get room type list for check list
  getRoomTypeBasedOnCheckList() {
    return axios
      .get(API_URL + "hk/check-list", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // get check list based on room type
  getCheckList(room_type_id) {
    return axios
      .get(API_URL + "hk/" + room_type_id + "/check-list", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // add check list based on room type
  postCheckList(room_type_id, data) {
    return axios
      .post(API_URL + "hk/" + room_type_id + "/check-list", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // get check list details based on room type
  getCheckListDetails(room_type_id, check_list_id) {
    return axios
      .get(API_URL + "hk/" + room_type_id + "/check-list/" + check_list_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // update check list based on room type
  updateCheckList(room_type_id, check_list_id, data) {
    return axios
      .patch(
        API_URL + "hk/" + room_type_id + "/check-list/" + check_list_id,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // delete check list based on room type
  deleteCheckList(room_type_id, check_list_id) {
    return axios
      .delete(API_URL + "hk/" + room_type_id + "/check-list/" + check_list_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // STAFF HEALTH SHEET RELATED APIs

  // get staff helth question list
  getStaffHealthSheetQuestionList(staff_helth_sheet_id) {
    return axios
      .get(API_URL + "hk/staff-health-sheet/" + staff_helth_sheet_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // update staff helth question answer
  updateStaffHealthSheetQuestionAnswer(question_id, data) {
    return axios
      .patch(
        API_URL + "hk/staff-health-sheet-question-answer/" + question_id,
        data,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  // DND RELATED APIs

  // get all dnd status
  getDNDReasonList() {
    return axios
      .get(API_URL + "hk/dnd-reason", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // create dnd reason
  createDNDReason(data) {
    return axios
      .post(API_URL + "hk/dnd-reason", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // update dnd reason
  updateDNDReason(dnd_reason_id, data) {
    return axios
      .patch(API_URL + "hk/dnd-reason/" + dnd_reason_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // delete dnd reason
  deleteDNDReason(dnd_reason_id) {
    return axios
      .delete(API_URL + "hk/dnd-reason/" + dnd_reason_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // DISCREPANCY RELATED APIs

  // get all discrepancy status
  getDiscrepancyReasonList() {
    return axios
      .get(API_URL + "hk/discrepancy", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // create discrepancy reason
  createDiscrepancyReason(data) {
    return axios
      .post(API_URL + "hk/discrepancy", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // update discrepancy reason
  updateDiscrepancyReason(disc_reason_id, data) {
    return axios
      .patch(API_URL + "hk/discrepancy/" + disc_reason_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // delete discrepancy reason
  deleteDiscrepancyReason(disc_reason_id) {
    return axios
      .delete(API_URL + "hk/discrepancy/" + disc_reason_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // MINI BAR ITEMS RELATED APIs

  // get all mini bar item
  getMiniBarItemList() {
    return axios
      .get(API_URL + "hk/mini-bar-item", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // get mini bar item in details
  getMiniBarItemDetails(item_id) {
    return axios
      .get(API_URL + "hk/mini-bar-item/" + item_id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // create mini bar item
  createMiniBarItem(data) {
    return axios
      .post(API_URL + "hk/mini-bar-item", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // update mini bar item
  updateMiniBarItem(item_id, data) {
    return axios
      .patch(API_URL + "hk/mini-bar-item/" + item_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // delete mini bar item
  deleteMiniBarItem(item_id) {
    return axios
      .delete(API_URL + "hk/mini-bar-item/" + item_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // TASK SHEET RELATED APIs

  // create task sheet
  createTaskSheet(data) {
    return axios
      .post(API_URL + "hk/task-sheet", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // get task sheet list
  getTaskSheetList() {
    return axios
      .get(API_URL + "hk/task-sheet", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // get single wise task sheet
  getTaskSheet(task_id) {
    return axios
      .get(API_URL + "hk/task-sheet/" + task_id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // get single wise task sheet
  updateTaskSheetData(id, data) {
    return axios
      .patch(API_URL + "hk/task-sheet/" + id, data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // update single task sheet value based on id
  updateTaskSheet(task_id, data) {
    return axios
      .patch(API_URL + "hk/staff-task/" + task_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // get task sheet based on date for staff
  getTaskSheetListByDate(date) {
    return axios
      .get(API_URL + "hk/staff-task-sheet?task_sheet__sheet_date=" + date, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // update task sheet based on date for staff
  updateTaskStatus(task_id, data) {
    return axios
      .patch(API_URL + "hk/staff-task/" + task_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // STAFF SHIFT RELATED APIs

  // get staff shift based on date
  getStaffShift(date) {
    return axios
      .get(API_URL + "hk/staff-shift?shift_date=" + date, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // create staff shift based on date
  createStaffShift(data) {
    return axios
      .post(API_URL + "hk/staff-shift", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // UNUSED FILEs

  // HEALTH QUESTION RELATED APIs

  // get health questions list
  getHealthSheetList() {
    return axios
      .get(API_URL + "hk/health-question", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // add health question
  createHealthQuestion(data) {
    return axios
      .post(API_URL + "hk/health-question", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // get health question details
  getHealthQuestionDetails(helth_question_id) {
    return axios
      .get(API_URL + "hk/health-question/" + helth_question_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // update health question
  updateHealthQuestion(helth_question_id, data) {
    return axios
      .patch(API_URL + "hk/health-question/" + helth_question_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // delete health question
  deleteHealthQuestion(helth_question_id) {
    return axios
      .delete(API_URL + "hk/health-question/" + helth_question_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // get staff helth sheet list
  getStaffHealthSheetList(date) {
    return axios
      .get(API_URL + "hk/staff-health-sheet?sheet_date=" + date, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // update staff helth sheet list
  updateStaffHelthSheet(staff_helth_sheet_id, data) {
    return axios
      .patch(API_URL + "hk/staff-health-sheet/" + staff_helth_sheet_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}
export default new HouseKeepingService();
